import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import FileDocumentPreview from '../FileDocumentPreview';

type Props = {
  open: boolean;
  onClose: () => void;
  previewUrl?: string | null;
  conteudo?: string | null;
  title?: string;
  downloadFileName?: string;
};

const useStyles = makeStyles(() => ({
  dialogPaper: {
    minWidth: 'min(960px, 95vw)',
  },
  dialogTitle: {
    color: '#373F41',
  },
}));

export default function VisualizarDocumentoDialog({
  open,
  onClose,
  previewUrl,
  conteudo,
  title = 'Documento',
  downloadFileName,
}: Props): JSX.Element {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent dividers>
        <FileDocumentPreview
          previewUrl={previewUrl}
          conteudo={conteudo}
          title={title}
          height='60vh'
          downloadFileName={downloadFileName}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='default'>
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
